import {
    bulkScenarioUpload,
    SET_UPLOAD_SUCCESS_STATUS,
    SET_EXTRACTION_REQUEST,
    SET_EXTRACTION_SUCCESS,
    SET_EXTRACTION_ERROR,
    // SET_BULK_UPLOAD_REQUEST,
    // SET_BULK_UPLOAD_SUCCESS,
    // SET_BULK_UPLOAD_ERROR
} from "../../constants/closeLoop/scenarioCollection/uploadBulkFilesConstants";
import { size } from "lodash";

const modifyBulkInputFiles = (
    existingFiles,
    scenarioFiles,
    sddFile,
    bulkFileSystem,
    simulator,
    model
) => {
    let fileToUpload = {};
    for (let i = 0; i < scenarioFiles.length; i++) {
        const id = size(existingFiles) + i + 1;

        fileToUpload = {
            ...fileToUpload,
            [id]: {
                id,
                file: scenarioFiles[i],
                progress: 0,
                sddFile,
                bulkFileSystem,
                simulator,
                model,
            },
        };
    }
    return fileToUpload;
};

const defaultState = {
    fileProgress: {},
};

export const inputFileUploadProgress = (state = defaultState, action) => {
    switch (action.type) {
        case bulkScenarioUpload().SET_BULK_INPUT_UPLOAD_FILE:
            return {
                ...state,
                fileProgress: {
                    ...state.fileProgress,
                    ...modifyBulkInputFiles(
                        state.fileProgress,
                        action.payload,
                        action.sddFile,
                        action.bulkFileSystem,
                        action.simulator,
                        action.model
                    ),
                },
            };
        case bulkScenarioUpload().SET_BULK_INPUT_UPLOAD_PROGRESS:
            return {
                ...state,
                fileProgress: {
                    ...state.fileProgress,
                    [action.payload.id]: {
                        ...state.fileProgress[action.payload.id],
                        progress: action.payload.progress,
                    },
                },
            };

        case bulkScenarioUpload().SUCCESS_UPLOAD_BULK_INPUT_FILE:
            return {
                ...state,
                fileProgress: {
                    ...state.fileProgress,
                    [action.payload]: {
                        ...state.fileProgress[action.payload],
                        status: 1,
                    },
                },
            };

        case bulkScenarioUpload().FAILURE_UPLOAD_BULK_INPUT_FILE:
            return {
                ...state,
                fileProgress: {
                    ...state.fileProgress,
                    [action.payload]: {
                        ...state.fileProgress[action.payload],
                        status: 0,
                        progress: 0,
                    },
                },
            };

        case bulkScenarioUpload().RESET_UPLOAD_BULK_INPUT_FILE:
            return {
                ...state,
                fileProgress: {},
            };
        default:
            return state;
    }
};

const initialStatus = {
    uploadStatus: false,
};
export const bulkInputFilesUploadStatus = (state = initialStatus, action) => {
    switch (action.type) {
        case SET_UPLOAD_SUCCESS_STATUS:
            return {
                uploadStatus: action.uploadStatus,
            };
        default:
            return state;
    }
};

const initialExtractiondata = {
    extractionStatusData: "",
    extractionStatus: false,
    error: "",
};

export const extractImagesAndDescription = (state = initialExtractiondata, action) => {
    switch (action.type) {
        case SET_EXTRACTION_REQUEST:
            return {
                extractionStatusData: "",
                extractionStatus: false,
                error: "",
            };
        case SET_EXTRACTION_SUCCESS:
            return {
                extractionStatusData: action.status.message,
                extractionStatus: true,
                error: "",
            };
        case SET_EXTRACTION_ERROR:
            return {
                extractionStatusData: "",
                extractionStatus: false,
                error: action.payload,
            };
        default:
            return state;
    }
};

const initialBulkUploadState = {
    loading: false,
    uploadStaus: {},
    error: "",
    message: "",
};

// export const uploadBulkScenarioFiles = (state = initialBulkUploadState, action) => {
//     switch (action.type) {
//         case SET_BULK_UPLOAD_REQUEST:
//             return {
//                 loading: true,
//                 uploadStaus: {},
//                 error: "",
//                 message: "",
//             };
//         case SET_BULK_UPLOAD_SUCCESS:
//             return {
//                 loading: false,
//                 uploadStaus: action.data,
//                 error: "",
//                 message: "",
//             };
//         case SET_BULK_UPLOAD_ERROR:
//             return {
//                 loading: false,
//                 uploadStaus: [],
//                 error: action.payload,
//                 message: "",
//             };
//         default:
//             return state;
//     }
// };

